import React from "react";

export const FieldInput = (props, ref) => {
  const {
    label,
    error,
    helperText,
    leftElement,
    rightElement,
    registration,
    height = "h-10",
    ...restProps
  } = props;
  const hasLabel = !!label;
  const isInvalid = !!props.error;

  const inputProps = {
    ref: ref,
    id: registration.name,
    ...restProps,
    ...registration,
  };

  const InputImpl = (
    <div className="flex gap-2">
      {leftElement}
      <input
        className={`border rounded-[4px] w-full ${height} text-[12px] p-2`}

        {...inputProps}
      />
      {rightElement}
    </div>
  );

  return (
    <div
      className={`
      ${props.type === "hidden" ? "none" : "block"}
      ${props.isDisabled ? "cursor-none" : ""}
      `}
    >
      {hasLabel ? (
        <>
          <label htmlFor={inputProps.id}>{label}</label>
          {InputImpl}
        </>
      ) : (
        <label m={0}>{InputImpl}</label>
      )}

      {!isInvalid && helperText ? <span>{helperText}</span> : null}
      {error ? <span className="text-red">{error.message}</span> : null}
    </div>
  );
};
